import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { ChevronDown } from "lucide-react";

// faqs: [{ q, a }] — renders an accordion and emits valid FAQPage JSON-LD
const FAQSection = ({ faqs, title = "Frequently Asked Questions" }) => {
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs || faqs.length === 0) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="section-padding bg-muted">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="container-custom max-w-3xl">
        <h2 className="font-montserrat text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">
          {title}
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={faq.q} className="bg-card rounded-lg shadow-sm border border-border overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left"
                aria-expanded={openIndex === i}
              >
                <span className="font-montserrat font-semibold text-foreground">{faq.q}</span>
                <ChevronDown
                  size={20}
                  className={`flex-shrink-0 text-primary transition-transform ${openIndex === i ? "rotate-180" : ""}`}
                  aria-hidden="true"
                />
              </button>
              {openIndex === i && (
                <div className="px-4 md:px-5 pb-4 md:pb-5 text-muted-foreground">{faq.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
